export function $(query, container) {
    if (container === void 0) { container = document; }
    var element = container.querySelector(query);
    if (element === null) {
        return;
    }
    return element;
}
//# sourceMappingURL=$.js.map